import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Reusable per-page SEO tags — title, meta description, canonical, and
 * matching Open Graph title/description. Set `noSchema=false` and pass
 * `schema` (a JSON-LD object) on the homepage to inject structured data.
 */
const PageMeta = ({ title, description, path = '/', schema = null }) => {
  const canonical = `https://www.bring-a-nurse-nc.com${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default PageMeta;
